import React, { Fragment } from 'react'
import { withRouteData } from 'react-static'

import SearchResultsGroup from './SearchResultsGroup'
// import SearchResultsLoader from './SearchResultsLoader'

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
}

const CategoryTitle = ({ title, contentType }) => (
    <Fragment>
        {capitalizeFirstLetter(contentType)}&nbsp;&mdash;{' '}
        {capitalizeFirstLetter(title)}
    </Fragment>
)

const SearchResults = ({ landscape }) => (
    <section className="section catalog">
        <div className="search-results">
            <div className="search-results__container container">
                {Object.keys(landscape).map(contentType => (
                    <Fragment key={`${contentType}`}>
                        {Object.keys(landscape[contentType]).map(
                            (category, idx) => (
                                <SearchResultsGroup
                                    key={idx}
                                    intentSlugs={
                                        landscape[contentType][category]
                                    }
                                    contentType={contentType}
                                    title={
                                        <CategoryTitle
                                            title={category}
                                            contentType={contentType}
                                        />
                                    }
                                />
                            )
                        )}
                    </Fragment>
                ))}
                {/* <SearchResultsLoader /> */}
            </div>
        </div>
    </section>
)

export default withRouteData(SearchResults)



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/SearchResults.jsx